import { brokerClientProtectionAdminApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// The policy endpoint is gated on the broker-home manage claim, which the page's
// SYSTEM_PROPERTIES route gate does not imply — a client-tenant admin without it
// 403s. Skip the global forbidden interceptor so that surfaces as the page's local
// error state instead of the page-reload loop (mirrors the Quality scorecard reads).
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_CLIENT_PROTECTION_ADMIN_ACTION_TYPE = createNamedActions(
  'commandCenterClientProtectionAdmin',
  {
    SET_CLIENT_PROTECTION: 'SET_CLIENT_PROTECTION',
    RESET_CLIENT_PROTECTION_STATE: 'RESET_CLIENT_PROTECTION_STATE',
  },
);

export const getCommandCenterClientProtectionAdminAction = catchAsyncActionError(
  ({ companyId } = {}) =>
    async dispatch => {
      const { data } = await brokerClientProtectionAdminApi.getClientProtection({
        companyId,
        config: SKIP_FORBIDDEN_CONFIG,
      });

      return dispatch({
        type: COMMAND_CENTER_CLIENT_PROTECTION_ADMIN_ACTION_TYPE.SET_CLIENT_PROTECTION,
        payload: data ?? null,
      });
    },
);

export const saveCommandCenterClientProtectionAction = catchAsyncActionError(
  params => async () => brokerClientProtectionAdminApi.saveClientProtection(params),
);

export const resetCommandCenterClientProtectionAdminStateAction = () => ({
  type: COMMAND_CENTER_CLIENT_PROTECTION_ADMIN_ACTION_TYPE.RESET_CLIENT_PROTECTION_STATE,
});
